"use client";
import { jsxs as a, jsx as l } from "react/jsx-runtime";
const d = ({
  title: c,
  titleId: h,
  desc: i,
  descId: e,
  ...r
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-110 1 511 512",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": h,
    "aria-describedby": e,
    ...r,
    children: [
      i ? /* @__PURE__ */ l("desc", { id: e, children: i }) : null,
      c ? /* @__PURE__ */ l("title", { id: h, children: c }) : null,
      /* @__PURE__ */ l("path", { d: "M180 512H98.0078c-13.6953 0-24.836-11.1406-24.836-24.836V302.2267H25.336C11.6406 302.2266.5 291.082.5 277.3906v-79.246c0-13.6954 11.1406-24.836 24.836-24.836h47.8359V133.625c0-39.3477 12.3554-72.8242 35.7265-96.8047C132.375 12.7305 165.1836 0 203.7774 0l62.5312.1016c13.6719.0234 24.793 11.164 24.793 24.8359v73.5781c0 13.6953-11.1368 24.836-24.8282 24.836l-42.1015.0156c-12.8399 0-16.1094 2.5742-16.8086 3.3633-1.1524 1.3086-2.5235 5.0078-2.5235 15.2226v31.3516h58.2696c4.3867 0 8.6367 1.082 12.289 3.121 7.879 4.4024 12.7774 12.7266 12.7774 21.7227l-.0313 79.2461c0 13.6875-11.1406 24.8282-24.836 24.8282h-58.4687V487.164C204.8398 500.8594 193.6953 512 180 512m-76.8125-30.0156h71.6328V288.789c0-9.1446 7.4414-16.582 16.582-16.582h66.7266l.0274-68.8829h-66.7579c-9.1406 0-16.578-7.4375-16.578-16.582v-44.789c0-11.7266 1.1913-25.0626 10.0429-35.086C195.5586 94.75 212.414 93.3516 224.164 93.3516l36.9218-.0157V30.1094l-57.332-.0938c-62.0234 0-100.5664 39.7032-100.5664 103.6094v53.1172c0 9.1406-7.4375 16.582-16.5781 16.582H30.5156v68.8828h56.0938c9.1406 0 16.5781 7.4375 16.5781 16.582zM266.25 30.1172h.004zm0 0" })
    ]
  }
);
export {
  d as default
};
